//
// IMPORTANT: We expect adal.js to be globally available as AuthenticationContext
//

const React = require("react");
const ReactDOM = require("react-dom");
const StateProvider = require("react-redux").Provider;
const ConnectToStore = require("react-redux").connect;
const msal = require("./MsalApi.js");

let store = require("./store.js");
let HistoryTicker = require("./HistoryTicker.js");
let Main = require("./components/Main.jsx");

Main = ConnectToStore((state) => state)(Main);

msal.initialize(loadUi);

function loadUi() {

    let main = document.getElementById("Main");

    ReactDOM.render(
        (<StateProvider store={store}>
            <Main />
        </StateProvider>), main);

    HistoryTicker.Start();
}


// WEBPACK FOOTER //
// ./src/start.jsx